import moment from "moment";

export default class Submission {
  constructor(data) {
    this.populateWithData(data);
  }

  populateWithData(data) {
    data = data || {};
    data = JSON.parse(JSON.stringify(data));
    // this.id = data.id || null;
    this.pid = data.pid || null;
    this.identifier = data.identifier || null;
    this.event_code = data.event_code || null;
    this.sample_type = data.sample_type || null;
    this.sample_type_id = data.sample_type.id || null;
    this.test_package = data.test_package || null;
    this.test_package_id = data.test_package.id || null;
    this.turnaround = data.turnaround || null;
    this.turnaround_id = data.turnaround_id || null;
    // this.submission_status_logs = data.submission_status_logs || [];

    if (data.submission_soil) {
      this.setSubmissionSoil(data.submission_soil);
    } else if (typeof this.submission_soil === "object") {
      delete this.submission_soil;
    }
    if (data.submission_potato) {
      this.setSubmissionPotato(data.submission_potato);
    } else if (typeof this.submission_potato === "object") {
      delete this.submission_potato;
    }
    if (data.submission_tissue) {
      this.setSubmissionTissue(data.submission_tissue);
    } else if (typeof this.submission_tissue === "object") {
      delete this.submission_tissue;
    }
    if (data.submission_feed_mixer_efficiency) {
      this.setSubmissionFeedMixer(data.submission_feed_mixer_efficiency);
    } else if (typeof this.submission_feed_mixer_efficiency === "object") {
      delete this.submission_feed_mixer_efficiency;
    }
    if (data.bore_holes) {
      this.setBoreHoles(data.bore_holes, data.samples);
    } else if (
      typeof this.bore_holes === "object" &&
      typeof this.samples === "object"
    ) {
      delete this.bore_holes;
      delete this.samples;
    }
    if (data.samples && !data.bore_holes) {
      this.setSamples(data.samples);
    } else if (typeof this.samples === "object" && !data.bore_holes) {
      delete this.samples;
    }
    return this;
  }

  setSubmissionSoil(data) {
    data = data || {};
    data = JSON.parse(JSON.stringify(data));

    const submission_soil = {
      grower: data.grower || null,
      irrigated: data.irrigated || null,
      projections: data.projections || [
        {
          crop: null,
          yield: null,
          unit: null
        }
      ],
      zone: data.zone || null
    };
    return (this.submission_soil = submission_soil);
  }

  setSubmissionPotato(data) {
    data = data || {};
    data = JSON.parse(JSON.stringify(data));
    const submission_potato = {
      grower: data.grower || null,
      storage_bin: data.storage_bin || null
    };
    return (this.submission_potato = submission_potato);
  }

  setSubmissionFeedMixer(data) {
    data = data || {};
    data = JSON.parse(JSON.stringify(data));
    const submission_feed_mixer_efficiency = {
      all_sample_types: data.all_sample_types || null
    };
    return (this.submission_feed_mixer_efficiency = submission_feed_mixer_efficiency);
  }

  setSubmissionTissue(data) {
    data = data || {};
    data = JSON.parse(JSON.stringify(data));

    const submission_tissue = {
      crop: data.crop || null,
      cropstage: data.cropstage || null
    };

    return (this.submission_tissue = submission_tissue);
  }

  setBoreHolesSamples(collection) {
    collection = collection || [];
    collection = JSON.parse(JSON.stringify(collection));
    if (!collection.length) {
      return [];
    }
    let samples = [];
    collection.forEach(data => {
      let sample = {
        identifier: data.identifier || null,
        test_package_sample_id: data.test_package_sample_id || null,
        sample_irrigation_suitability: {
          number: data.sample_irrigation_suitability.number || null,
          bore_hole: data.sample_irrigation_suitability.bore_hole || null,
          depth_end: data.sample_irrigation_suitability.depth_end || null,
          depth_start: data.sample_irrigation_suitability.depth_start || null,
          field_texture:
            data.sample_irrigation_suitability.field_texture || null,
          soil_horizon: data.sample_irrigation_suitability.soil_horizon || null
        }
      };
      if (data.add_ons) {
        sample.add_ons = data.add_ons;
      } else {
        sample.add_ons = [];
      }
      samples = [...samples, sample];
    });
    return samples;
  }

  setSamples(collection) {
    collection = collection || [];
    collection = JSON.parse(JSON.stringify(collection));

    if (!collection.length) {
      return (this.samples = []);
    }

    let samples = [];
    collection.forEach(data => {
      let sample = {
        identifier: data.identifier || null,
        test_package_sample_id: data.test_package_sample_id || null
      };

      if (data.sample_soil) {
        sample.sample_soil = {
          depth_start: data.sample_soil.depth_start || null,
          depth_end: data.sample_soil.depth_end || null,
          depth_total: data.sample_soil.depth_total || null
        };
      }

      if (data.sample_potato) {
        sample.sample_potato = {
          field: data.sample_potato.field || null,
          harvest_date: data.sample_potato.harvest_date || null
        };
      }

      if (data.sample_feeds) {
        sample.sample_feeds = {
          type: data.sample_feeds.type || null,
          animal_fed: data.sample_feeds.animal_fed || null
        };
      }

      if (data.sample_feed_mixer_efficiency) {
        sample.sample_feed_mixer_efficiency = {
          type: data.sample_feed_mixer_efficiency.type || null
        };
      }

      if (data.sample_septic) {
        sample.sample_septic = {
          depth_start: data.sample_septic.depth_start || null,
          depth_end: data.sample_septic.depth_end || null,
          depth_total: data.sample_septic.depth_total || null,
          texture: data.sample_septic.texture || null,
          sieve: data.sample_septic.sieve || null,
          sar: data.sample_septic.sar || null,
          ec: data.sample_septic.ec || null,
          cole: data.sample_septic.cole || null,
          dispersion: data.sample_septic.dispersion || null
        };
      }

      if (data.sample_irrigation_suitability) {
        sample.sample_irrigation_suitability = {
          number: data.sample_irrigation_suitability.number || null,
          bore_hole: data.sample_irrigation_suitability.bore_hole || null,
          depth_end: data.sample_irrigation_suitability.depth_end || null,
          depth_start: data.sample_irrigation_suitability.depth_start || null,
          field_texture:
            data.sample_irrigation_suitability.field_texture || null,
          soil_horizon: data.sample_irrigation_suitability.soil_horizon || null
        };
      }

      if (data.add_ons) {
        sample.add_ons = data.add_ons;
      } else {
        sample.add_ons = [];
      }
      samples = [...samples, sample];
    });
    return (this.samples = collection);
  }

  setBoreHoles(bore_hole_collections, sample_collections) {
    bore_hole_collections = bore_hole_collections || [];
    bore_hole_collections = JSON.parse(JSON.stringify(bore_hole_collections));
    if (!bore_hole_collections.length) {
      return (this.bore_holes = []);
    }
    sample_collections = sample_collections || [];
    sample_collections = JSON.parse(JSON.stringify(sample_collections));
    if (!sample_collections.length) {
      return (this.samples = []);
    }
    let bore_holes = [];
    bore_hole_collections.forEach(data => {
      let bore_hole = {
        bore_hole_id: data.bore_hole_id || null,
        identifier: data.identifier || null,
        field_texture: data.field_texture || null,
        soil_horizon: data.soil_horizon || null
      };
      if (data.samples) {
        bore_hole.samples = this.setBoreHolesSamples(data.samples);
      } else if (typeof bore_hole.samples === "object") {
        delete bore_hole.samples;
      }
      bore_holes = [...bore_holes, bore_hole];
    });
    return (
      (this.bore_holes = bore_hole_collections),
      (this.samples = sample_collections)
    );
  }

  getSampleType() {
    return this.sample_type ? this.sample_type : null;
  }

  getTestPackage() {
    return this.test_package ? this.test_package : null;
  }

  getTitle() {
    let test_package = this.getTestPackage();
    let title = [
      this.sample_type ? this.sample_type.name : null,
      this.identifier || null,
      test_package ? test_package.name : null
    ];
    let filtered = title.filter(Boolean);
    return filtered.join(" - ");
  }

  static formatField(field) {
    return field
      .split("_")
      .join(" ")
      .replace(/^(.)|\s+(.)/g, function(j) {
        return j.toUpperCase();
      });
  }

  getStatus() {
    if (this.submission_status_logs && this.submission_status_logs.length) {
      let log = this.submission_status_logs[0];
      if (log.submission_status) {
        return log.submission_status.status;
      }
    }
    return null;
  }

  getTestPackageCost() {
    let test_package = this.getTestPackage();
    if (test_package && test_package.cost) {
      return +test_package.cost;
    }
    return null;
  }

  getAddOnsFromSample(sample) {
    let add_ons = [];
    if (sample.add_ons && sample.add_ons.length) {
      sample.add_ons.forEach(add_on => {
        if (add_on.cost_add_on) {
          add_ons = [...add_ons, add_on];
        }
      });
    }
    return add_ons;
  }

  getAddOns() {
    let add_ons = [];
    if (this.samples && this.samples.length) {
      this.samples.forEach(sample => {
        if (sample.add_ons && sample.add_ons.length) {
          sample.add_ons.forEach(add_on => {
            if (add_on.cost_add_on) {
              add_ons = [...add_ons, add_on];
            }
          });
        }
      });
    }
    return add_ons;
  }

  getAddOnTotal() {
    let total = null;
    if (this.samples && this.samples.length) {
      total = 0;
      this.getAddOns().forEach(add_on => {
        if (add_on.cost_add_on) {
          total += +add_on.cost_add_on;
        }
      });
    }
    return total;
  }

  getTotal(applyTurnaraound) {
    let total = this.getTestPackageCost() || 0;
    total += this.getAddOnTotal() || 0;
    if (applyTurnaraound) {
      if (this.turnaround) {
        switch (this.turnaround.surcharge_type) {
          case "percent":
            total = total * (1 + +this.turnaround.surcharge / 100);
            break;
          case "flat":
            total += +this.turnaround.surcharge;
            break;
        }
      }
    }
    return total ? total : null;
  }

  static formatValue(type, value) {
    switch (type) {
      case "datetime":
        return moment(value).format("dddd, MMMM Do YYYY, h:mm a");
      case "boolean":
        return !+value ? "Yes" : "No";
    }
    return value;
  }

  getSubmissionMetaData() {
    let meta = [];

    let included = ["identifier", "event_code"];
    let types = { created_at: "datetime", updated_at: "datetime" };
    included.forEach(key => {
      meta = [
        ...meta,
        {
          label: this.constructor.formatField(key),
          value: this.constructor.formatValue(types[key], this[key])
        }
      ];
    });

    if (this.submission_soil) {
      included = ["grower", "zone", "irrigated", "projections"];
      types = { irrigated: "boolean" };
      included.forEach(key => {
        if (!this.submission_soil[key]) {
          return;
        }
        meta = [
          ...meta,
          {
            label: this.constructor.formatField(key),
            value: this.constructor.formatValue(
              types[key],
              this.submission_soil[key]
            )
          }
        ];
      });
    }

    if (this.submission_feed_mixer_efficiency) {
      included = ["all_sample_types"];
      types = { all_sample_types: "string" };
      included.forEach(key => {
        if (!this.submission_feed_mixer_efficiency[key]) {
          return;
        }
        meta = [
          ...meta,
          {
            label: this.constructor.formatField(key),
            value: this.constructor.formatValue(
              types[key],
              this.submission_feed_mixer_efficiency[key]
            )
          }
        ];
      });
    }

    if (this.submission_potato) {
      included = ["grower", "storage_bin"];
      types = { grower: "string", storage_bin: "string" };
      included.forEach(key => {
        if (!this.submission_potato[key]) {
          return;
        }
        meta = [
          ...meta,
          {
            label: this.constructor.formatField(key),
            value: this.constructor.formatValue(
              types[key],
              this.submission_potato[key]
            )
          }
        ];
      });
    }

    if (this.submission_tissue) {
      included = ["crop", "cropstage"];
      types = { crop: "string", cropstage: "string" };
      included.forEach(key => {
        if (!this.submission_tissue[key]) {
          return;
        }
        meta = [
          ...meta,
          {
            label: this.constructor.formatField(key),
            value: this.constructor.formatValue(
              types[key],
              this.submission_tissue[key]
            )
          }
        ];
      });
    }
    return meta;
  }

  getTurnaroundText() {
    if (this.turnaround) {
      switch (this.turnaround.surcharge_type) {
        case "percent":
          return (
            this.turnaround.name +
            "(" +
            this.turnaround.surcharge +
            "% Surcharge)"
          );
        case "flat":
          return (
            this.turnaround.name +
            "($" +
            this.turnaround.surcharge +
            " Surcharge)"
          );
      }
    }
    return null;
  }

  getSamples() {
    let samples = this.samples || null;
    if (!samples) {
      return samples;
    }

    samples.forEach((sample, index) => {
      sample.title = null;
      if (sample.test_package_samples && sample.test_package_samples.length) {
        sample.title = sample.test_package_samples[0].name || null;
      }

      sample.status = null;
      if (sample.sample_status_logs && sample.sample_status_logs.length) {
        let log = sample.sample_status_logs[0];
        if (log.sample_status) {
          sample.status = log.sample_status.status;
        }
      }

      let meta = [];

      if (sample.sample_feeds) {
        const included = ["type", "animal_fed"];
        const types = {
          type: "string",
          animal_fed: "string"
        };
        included.forEach(key => {
          if (!sample.sample_feeds[key]) {
            return;
          }
          meta = [
            ...meta,
            {
              label: this.constructor.formatField(key),
              value: this.constructor.formatValue(
                types[key],
                sample.sample_feeds[key]
              )
            }
          ];
        });
      }

      if (sample.sample_feed_mixer_efficiency) {
        const included = ["type"];
        const types = {
          type: "string"
        };
        included.forEach(key => {
          if (!sample.sample_feed_mixer_efficiency[key]) {
            return;
          }
          meta = [
            ...meta,
            {
              label: this.constructor.formatField(key),
              value: this.constructor.formatValue(
                types[key],
                sample.sample_feed_mixer_efficiency[key]
              )
            }
          ];
        });
      }

      if (sample.sample_potato) {
        const included = ["field", "harvest_date"];
        const types = {
          field: "string",
          harvest_date: "datetime"
        };
        included.forEach(key => {
          if (!sample.sample_potato[key]) {
            return;
          }
          meta = [
            ...meta,
            {
              label: this.constructor.formatField(key),
              value: this.constructor.formatValue(
                types[key],
                sample.sample_potato[key]
              )
            }
          ];
        });
      }

      if (sample.sample_soil) {
        let included = [
          "depth_start",
          "depth_end",
          "depth_total",
          "created_at",
          "updated_at"
        ];
        let types = { created_at: "datetime", updated_at: "datetime" };
        included.forEach(key => {
          if (!sample.sample_soil[key]) {
            return;
          }
          meta = [
            ...meta,
            {
              label: this.constructor.formatField(key),
              value: this.constructor.formatValue(
                types[key],
                sample.sample_soil[key]
              )
            }
          ];
        });
      }

      if (sample.sample_septic) {
        let included = [
          "depth_start",
          "depth_end",
          "depth_total",
          "texture",
          "sieve",
          "sar",
          "ec",
          "cole",
          "dispersion",
          "created_at",
          "updated_at"
        ];
        let types = {
          sar: "boolean",
          ec: "boolean",
          cole: "boolean",
          dispersion: "boolean",
          created_at: "datetime",
          updated_at: "datetime"
        };
        included.forEach(key => {
          if (!sample.sample_septic[key]) {
            return;
          }
          meta = [
            ...meta,
            {
              label: this.constructor.formatField(key),
              value: this.constructor.formatValue(
                types[key],
                sample.sample_septic[key]
              )
            }
          ];
        });
      }

      sample.cost = null;
      if (sample.add_ons) {
        let add_ons = [];
        let cost = 0;
        sample.add_ons.forEach(add_on => {
          add_ons = [...add_ons, add_on.name];
          if (add_on.cost_add_on) {
            cost += +add_on.cost_add_on;
          }
        });
        if (add_ons.length) {
          meta = [...meta, { label: "Add Ons", value: add_ons.join(", ") }];
        }
        if (cost) {
          sample.cost = cost;
        }
      }

      sample.meta = [];
      sample.meta = meta;

      samples[index] = sample;
    });

    return samples;
  }

  validate() {
    let errors = [];

    if (!this.identifier) {
      errors = [...errors, "Identifier is required"];
    }

    if (this.bore_holes) {
      this.bore_holes.forEach(bore_hole => {
        if (!bore_hole.identifier) {
          errors = [...errors, "Bore Hole identifier is required"];
        }
        if (!bore_hole.field_texture) {
          errors = [...errors, "Bore Hole field texture is required"];
        }
        if (!bore_hole.soil_horizon) {
          errors = [...errors, "Bore Hole soil horizon is required"];
        }
      });
    }

    if (this.submission_soil) {
      if (!this.submission_soil.grower) {
        errors = [...errors, "Grower is required"];
      }
    }

    if (this.submission_tissue) {
      if (!this.submission_tissue.crop) {
        errors = [...errors, "Crop is required"];
      }
      if (!this.submission_tissue.cropstage) {
        errors = [...errors, "Crop stage is required"];
      }
    }

    if (this.submission_potato) {
      if (!this.submission_potato.grower) {
        errors = [...errors, "Grower is required"];
      }
      if (!this.submission_potato.storage_bin) {
        errors = [...errors, "Storage bin is required"];
      }
    }

    if (this.submission_feed_mixer_efficiency) {
      if (!this.submission_feed_mixer_efficiency.all_sample_types) {
        errors = [...errors, "All sample types is required"];
      }
    }

    if (this.samples && this.samples.length) {
      this.samples.forEach(sample => {
        if (!sample.identifier) {
          errors = [...errors, "Sample identifier is required"];
        }
        if (!sample.test_package_sample_id) {
          errors = [...errors, "Sample test package not specified"];
        }
        if (sample.sample_soil) {
          if (
            !sample.sample_soil.depth_start &&
            sample.sample_soil.depth_start !== 0
          ) {
            errors = [...errors, "Depth start is required"];
          }
          if (
            !sample.sample_soil.depth_end &&
            sample.sample_soil.depth_end !== 0
          ) {
            errors = [...errors, "Depth end not specified"];
          }
          if (
            !sample.sample_soil.depth_total &&
            sample.sample_soil.depth_total !== 0
          ) {
            errors = [...errors, "Depth total not specified"];
          }
        }
        if (sample.sample_septic) {
          if (
            !sample.sample_septic.depth_start &&
            sample.sample_septic.depth_start !== 0
          ) {
            errors = [...errors, "Depth start is required"];
          }
          if (
            !sample.sample_septic.depth_end &&
            sample.sample_septic.depth_end !== 0
          ) {
            errors = [...errors, "Depth end not specified"];
          }
          if (
            !sample.sample_septic.depth_total &&
            sample.sample_septic.depth_total !== 0
          ) {
            errors = [...errors, "Depth total not specified"];
          }
          if (!sample.sample_septic.texture) {
            errors = [...errors, "Texture not specified"];
          }
        }
        if (sample.sample_feeds) {
          if (!sample.sample_feeds.type) {
            errors = [...errors, "Sample type is required"];
          }
          if (!sample.sample_feeds.animal_fed) {
            errors = [...errors, "Sample animal fed is required"];
          }
        }
        if (sample.sample_potato) {
          if (!sample.sample_potato.field) {
            errors = [...errors, "Sample field is required"];
          }
          if (!sample.sample_potato.harvest_date) {
            errors = [...errors, "Sample harvest date is required"];
          }
        }
        if (sample.sample_feed_mixer_efficiency) {
          if (!sample.sample_feed_mixer_efficiency.type) {
            errors = [...errors, "Sample type is required"];
          }
        }
        if (sample.sample_irrigation_suitability) {
          if (
            !sample.sample_irrigation_suitability.depth_start &&
            sample.sample_irrigation_suitability.depth_start !== 0
          ) {
            errors = [...errors, "Depth start is required"];
          }
          if (
            !sample.sample_irrigation_suitability.depth_end &&
            sample.sample_irrigation_suitability.depth_end !== 0
          ) {
            errors = [...errors, "Depth end not specified"];
          }
        }
      });
    } else {
      errors = [...errors, "Samples are missing"];
    }

    return { status: +!errors.length, errors };
  }
}
